import React from "react";
import { Link } from "gatsby";
import "./PropertyCardOffer.scss";
import Offertag from "../Offertag/Offertag";
import CountDown from "../Countdown/CountDown";
import propertyImg from '../../images/img_1400.jpg';
import ScrollAnimation from 'react-animate-on-scroll'; 
import { ShowProcessedImage } from "../common/ggfx-client/module/components/show-image";
import imageConfig from "../../../static/images/config.json";
import HTMLReactParser from "html-react-parser";
import moment from "moment";

const PropertyCardOffer = (props) => {
    const propertyList = props.propertyList;
    // const newTime = new Date(2022,3,1,23,59,59,0); // YYYY (M-1) D H m s ms (start time and date from DB)
    var newTime = new Date(moment().endOf('week').subtract("hours", 8));
    let openHours = "";
    let start = -1;
    let end = 1;
    
    if(propertyList.openHours && propertyList.openHours.length > 0){
        propertyList.openHours.map((open)=>{
            if(open[moment().format("YYYY-MM-DD")]){
                openHours = open[moment().format("YYYY-MM-DD")]
            }
        })
        if(openHours){
            start = moment().diff(moment(openHours.start_date))
            end = moment().diff(moment(openHours.end_date))
            newTime = new Date(moment(openHours.end_date)); 
        }
  
    }
    console.log('textOnly', openHours)
    return (
        <React.Fragment>
            <ScrollAnimation animateIn="fadeInUp">
                <div className="property-card-offer img-zoom">
                    <div className="properties-wrapper">
                        <Link to={propertyList.propertyLink} className="overflow-hidden">
                            {props.searchResults ?
                                <React.Fragment>
                                    {propertyList?.propertyImg?.length > 0 ? 
                                        <ShowProcessedImage
                                            images={propertyList.propertyImg[0]}
                                            transforms={
                                                imageConfig.properties.images.list.sizes
                                            }
                                        /> 
                                        : 
                                        <picture>
                                            <img src={propertyImg} alt="img" />
                                        </picture>
                                    }
                                </React.Fragment> :
                                <picture>
                                    <img src={propertyList.propertyImg} alt="img" />
                                </picture>
                            }
                        </Link>
                        <Offertag text={propertyList.offerText} />
                    </div>
                    <div className="about-properties">
                        <div className="properties-info">
                            <div className="properties-heading">
                                <h2><Link to={propertyList.propertyLink}> {propertyList.propertyTitle}</Link></h2>
                                <span className="property-price">{propertyList.propertyPrice} {!propertyList.propertyStatus ? "PW": ""} {propertyList?.price_qualifier == "Offers In Excess" ? propertyList.price_qualifier : ""}</span>
                            </div>
                            <p>{propertyList.propertyInfo}</p>
                            <div className="properties-icons">
                                {parseInt(propertyList.propertyRoom) > 0 && 
                                    <span className="text">
                                        <i className="icon-bedroom"></i>
                                        <span className="sm-text">{propertyList.propertyRoom}</span>
                                    </span>
                                }

                                {parseInt(propertyList.propertyBathroom) > 0 && 
                                    <span className="text">
                                        <i className="icon-bath"></i>
                                        <span className="sm-text">{propertyList.propertyBathroom}</span>
                                    </span>
                                }

                                {parseInt(propertyList.propertyReception) > 0 && 
                                    <span className="text">
                                        <i className="icon-sofa"></i>
                                        <span className="sm-text">{propertyList.propertyReception}</span>
                                    </span>
                                }

                            </div>
                            <p className="property-text">{HTMLReactParser(propertyList.propertyDesc)}</p>
                        </div>
                        {start >= 0 && end < 0 && openHours != "" &&
                            <div className="counter-block">
                                <span className="counter-title">Open House ends in</span>
                                <CountDown defineTime={newTime}/>
                            </div>
                        }
                    </div>
                </div>
            </ScrollAnimation>
        </React.Fragment>
    );
};

export default PropertyCardOffer;
